import React from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';
import classNames from 'classnames';
import styles from './draggable-options-list.module.scss';

const DraggableOptionsList = ({
	options,
	handleDragOption,
	disabled,
	featureFlags,
	handlePercentageInput,
	shouldShowPercentageInput,
	handleRemoveDraggableOption,
	shouldShowRemoveDraggableOption,
	isDragDisabled = false,
	invalidPercents = false
}) => {
	return (
		<DragDropContext onDragEnd={handleDragOption}>
			<Droppable droppableId="droppable">
				{provided => (
					<div
						data-test-id="fleet-router-rule-body-right-side-draggable"
						{...provided.droppableProps}
						ref={provided.innerRef}
						className={classNames(styles['rule-draggable-list'], {
							[styles['rule-disabled-draggable']]: disabled
						})}
					>
						{options &&
							options.length > 0 &&
							options.map((item, index) => (
								<Draggable
									key={item.value}
									draggableId={item.value}
									index={index}
									isDragDisabled={isDragDisabled || disabled}
								>
									{provided => (
										<div
											ref={provided.innerRef}
											{...provided.draggableProps}
											{...provided.dragHandleProps}
											className={styles['rule-draggable-item']}
										>
											<div className={styles['rule-item-icon']}>
												<BringgIcon iconName={BringgFontIcons.Drag} />
											</div>
											<div className={styles['rule-item-text']}>{`${index + 1}. ${
												item.key
											}`}</div>

											{featureFlags?.enableRatioPercentage &&
												shouldShowPercentageInput &&
												shouldShowRemoveDraggableOption && (
													<div className={styles['rule-item-input-and-remove']}>
														<input
															className={classNames(styles['input-container'], {
																[styles['input-container-error']]:
																	(invalidPercents || item.error) && !disabled
															})}
															value={`${item.ratio}%`}
															onChange={handlePercentageInput(item)}
														/>

														<button
															className={styles['draggable-remove-button']}
															onClick={handleRemoveDraggableOption(item)}
															data-test-id="draggable-remove-button"
														>
															<BringgIcon iconName={BringgFontIcons.Close} />
														</button>
													</div>
												)}
										</div>
									)}
								</Draggable>
							))}
						{provided.placeholder}
					</div>
				)}
			</Droppable>
		</DragDropContext>
	);
};

export default DraggableOptionsList;
